<template>
  <div v-text="title" class="headline"></div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: 'Untitled'
    }
  }
}
</script>
